import styled from 'styled-components';

import { Container } from '../Blocks'
import mediainjector from '../../style/mediainjector';


export const ContainerGuide = styled(Container)`
  ul:first-of-type {
    margin: 0px;
    padding: 0px;
    li{
      list-style: none;
      a{
        text-decoration: none;
        border-bottom: 1px solid #dedede;
        padding: 5px;
        display: block;
        width: 100%;
        color: black;
        font-size: 1.2em;
        &:active {
          background-color: rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
  img {
    width: 100%;
    max-width: 100%;
    margin: 30px 0;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.15);
    ${mediainjector.lt667`
      margin: 10px 0;
    `}
  }
  img[title="not-100"]{
    width:200px;
    border: none;
    box-shadow: none;
  }
  ul img {
    display: inline;
    width: auto;
    margin: 0;
    border-radius: 0;
    border: none;
    box-shadow: none;
    width: 24px;
    ${mediainjector.lt667`
      width: 18px;
    `}
  }
  h2 {
    margin: 42px auto 21px;
  }
  h3 {
    margin: 21px auto 16px;
  }
`;

export const ButtonTop = styled.a`
  display:block;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width:60px;
  height:60px;
  overflow: visible;
  z-index: 100;
  svg {
    width:60px;
    height:60px;
  }
  ${mediainjector.lt667} {
    width:40px;
    height:40px;
    svg {
      width:40px;
      height:40px;
    }
  }
`; 
